// frontend/styleguide/index.js

import './index.scss';

import 'ez-styles/assets/js/utils/errors';

import 'ez-styles/assets/js/forms/general';
import 'ez-styles/assets/js/forms/password_field';

import './icons/pro-star.svg';
import './tmp-icons/arrow-rounded-left.svg';
